import { useQuery } from "@tanstack/react-query";

import { layoutNestingQuery } from "../infra/layoutNesting.query";

export const useLayoutNesting = (layoutId: string | undefined | null) => {
  const { data: nestingRun, ...rest } = useQuery(layoutNestingQuery(layoutId));

  return { nestingRun: nestingRun ?? null, ...rest };
};
